import { render, staticRenderFns } from "./gsz.vue?vue&type=template&id=350b6504&scoped=true&"
import script from "./gsz.vue?vue&type=script&lang=js&"
export * from "./gsz.vue?vue&type=script&lang=js&"
import style0 from "./gsz.vue?vue&type=style&index=0&id=350b6504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b6504",
  null
  
)

export default component.exports